import { ORDER_TOKEN_PARAM } from "./ticketsLink"

/**
 * Token do pedido que chegou no link público (`?k=`), tirado da barra de
 * endereço no boot (`src/index.tsx`, antes do render): os trackers por evento
 * (GA4 / Meta Pixel) podem rodar antes da página dos ingressos montar e leem
 * a URL. Fica guardado junto com o caminho em que chegou.
 */
let taken: { token: string; pathname: string } | null = null

/** Lê `k` da URL, guarda e remove da barra de endereço (resto da URL e state intactos). */
export const takeLinkTokenFromUrl = (): void => {
  taken = null
  try {
    const params = new URLSearchParams(window.location.search)
    if (!params.has(ORDER_TOKEN_PARAM)) return

    const token = params.get(ORDER_TOKEN_PARAM) ?? ""
    params.delete(ORDER_TOKEN_PARAM)

    const { pathname, hash } = window.location
    const query = params.toString()
    window.history.replaceState(
      window.history.state,
      "",
      `${pathname}${query ? `?${query}` : ""}${hash}`,
    )

    if (token) taken = { token, pathname }
  } catch {}
}

/**
 * Token guardado no boot ("" quando não tem). Vale só para a página em que
 * chegou, e pode ser lido mais de uma vez nela (a página lê ao montar);
 * navegando para outra página da loja não é reaproveitado.
 */
export const consumeLinkToken = (): string =>
  taken && taken.pathname === window.location.pathname ? taken.token : ""
